<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getLocationForecastReport()"
>
  <form class="location-forecast-container" [formGroup]="locationForecastForm">
    <!-- Date -->
    <ion-row>
      <ion-col size="11.5">
        <div class="form-group form-group-lg no-margin">
          <label>{{ CONSTS.DATE_LABEL }}</label>
        </div>
        <app-form-date-picker
          [minDate]="minDate"
          [maxDate]="maxDate"
          formControlName="date"
          class="report-date-picker"
          [icon]="SRC.CALENDAR"
        ></app-form-date-picker>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>
